import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "table",
  "use": "table-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"table\"><title>table</title><path d=\"M3.815 3.815V16H16V3.815H3.815zm3.816 11.57h-3.2v-3.2h3.2v3.2zm0-3.816h-3.2v-3.2h3.2v3.2zm0-3.938h-3.2v-3.2h3.2v3.2zm3.938 7.754h-3.2v-3.2h3.2v3.2zm0-3.816h-3.2v-3.2h3.2v3.2zm0-3.938h-3.2v-3.2h3.2v3.2zm3.816 7.754h-3.2v-3.2h3.2v3.2zm0-3.816h-3.2v-3.2h3.2v3.2zm0-3.938h-3.2v-3.2h3.2v3.2zM.615.615h3.2v1.6h.615v-1.6h3.2v1.6h.615v-1.6h3.2v1.6h.615V0H-.002v12.185h2.215v-.615h-1.6v-3.2h1.6v-.738h-1.6v-3.2h1.6v-.615h-1.6v-3.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/icons/table.svg
// module id = 28
// module chunks = 0